import { Pipe, PipeTransform } from '@angular/core';

//
//  Usage example:
//  <span [innerHtml]="whateverValue | highlightMatch: matchTerm"></span>
//

@Pipe({ name: 'highlightMatch' })
export class HighlightMatchPipe implements PipeTransform {
    transform(value: string, matchString: string, matchOptions: string = 'im', wrapper: string = '<span class="highlight-match strong">$1</span>'): string {
        if(!value || typeof value !== 'string' || !matchString || typeof matchString !== 'string') return value;

        const groupMatch = `(${matchString})`;
        const regExp = new RegExp(groupMatch, matchOptions);
        const matchResults = value.match(regExp);
        if(!matchResults) return value;

        return value.replace(regExp, wrapper);
    }
}

